.degree {
  position: relative;
  color: var(--tuna-palette-action-active);
  padding-left: 1px;
  top: -4px;
  font-size: 0.7em; /* tuna-allow: superscript scales with its note name */
}
